import dayjs from 'dayjs'
import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { usePageInfo } from '../config/queries'
import { useUpcomingEventDetails } from './UpcomingEvent'
import EventAvatar from './EventAvatar'
import EventStatusIcon from './EventStatusIcon'
import { CharacterClassIcon } from '.'
import Card from './Card'
import { eventInstant } from '../helpers/eventInstant'

const DetailedEvent = ({
  eventReference,
}: {
  eventReference: wowaudit.EventReference
}) => {
  const {
    data: { user },
  } = usePageInfo()
  const {
    characterReference,
    amountPresent,
    participants,
    hasSufficientParticipants,
  } = useUpcomingEventDetails(eventReference)
  const startsAt = eventInstant(
    eventReference.startsAt,
    eventReference.timezone,
  )

  return (
    <div className='hidden sm:block'>
      <div className='grid grid-cols-[minmax(0,1fr)_9rem_11rem_4rem] items-center gap-4 w-full'>
        <div className='flex items-center gap-2 min-w-0'>
          <EventAvatar eventReference={eventReference} className='h-10 w-10' />
          <div className='min-w-0'>
            <header className='capitalize truncate group-hover:text-primary transition-colors'>
              {eventReference.title}
            </header>

            <div className={'capitalize text-xs text-muted-foreground'}>
              {eventReference.primaryDifficulty?.replace('_', ' ')}
            </div>
          </div>
        </div>

        <Tooltip>
          <TooltipTrigger className='text-center'>
            <div>
              {startsAt.isBefore(dayjs()) ? 'started ' : ''}
              {startsAt.fromNow()}
            </div>

            <div className='text-xs text-muted-foreground'>
              {dayjs(eventReference.startsAt).format('HH:mm')} -{' '}
              {dayjs(eventReference.endsAt).format('HH:mm')}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            {dayjs(eventReference.startsAt).format('dddd, D MMM YYYY')}
          </TooltipContent>
        </Tooltip>

        {characterReference ? (
          <Card className='flex items-center gap-3 py-1 px-4 h-8 justify-self-center'>
            <CharacterClassIcon
              size='medium'
              characterClass={characterReference.characterClass}
            />
            <span className='truncate'>{characterReference.name}</span>
            <EventStatusIcon
              status={participants[characterReference.id].status}
            />
          </Card>
        ) : (
          <Card className='py-1 px-4 text-muted-foreground h-8 justify-self-center'>
            {user ? 'Not signed up' : 'Not logged in'}
          </Card>
        )}

        <span className={`flex text-base gap-1 justify-self-end`}>
          <span
            className={cn(
              hasSufficientParticipants
                ? 'text-success-foreground'
                : 'text-warning-foreground',
            )}
          >
            {amountPresent}
          </span>
          <span>/</span>
          <span>{eventReference.participantReferences.length}</span>
        </span>
      </div>
    </div>
  )
}

export default DetailedEvent
